export var SearchController = (function () {
  let _container = null
  const _perPage = 12
  let _page = 0
  let _path = null
  let _name = null
  let _finishEvent = null
  let _spinner = null
  let _finished = false
  let _observer = null

  function load(callback) {
    if (_finished) return

    _page++

    if (_spinner) {
      _spinner.show()
    }

    const requestUrl = `${_path}?q=${encodeURIComponent(_name)}&per_page=${_perPage}&page=${_page}`

    $.ajax({
      url: requestUrl,
      dataType: 'html',
      success(data) {
        const trimmed = $.trim(data)

        if (trimmed) {
          _container.append(trimmed)
        } else {
          _finished = true

          if (typeof _finishEvent === 'function') {
            _finishEvent(_page)
          }

          // stop observing if there are no more results
          if (_observer) {
            _observer.disconnect()
          }
        }

        if (_spinner) {
          _spinner.hide()
        }

        if (typeof callback === 'function') {
          callback()
        }
      },
      error() {
        if (_spinner) {
          _spinner.hide()
        }
        if (typeof callback === 'function') {
          callback()
        }
      },
    })
  }

  function init(container, path, name) {
    _container = container
    _path = path
    _name = name

    // IntersectionObserver
    const trigger = document.querySelector('.scroll-trigger')
    if (trigger) {
      _observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              load()
            }
          })
        },
        {
          rootMargin: '200px',
          threshold: 0.1,
        }
      )
      _observer.observe(trigger)
    }
  }

  function reset() {
    _page = 0
    _finished = false
  }

  function set_page_number(page) {
    _page = page
  }

  function get_page_number() {
    return _page
  }

  function set_finish_event(finishEvent) {
    _finishEvent = finishEvent
  }

  function set_spinner(spinner) {
    _spinner = spinner
  }

  return {
    init,
    reset,
    load,
    set_page_number,
    get_page_number,
    set_finish_event,
    set_spinner,
  }
})()
